// extracted by mini-css-extract-plugin
module.exports = {"graph":"MonthCard_graph__MVbAH","grid":"MonthCard_grid__oXvX6","data":"MonthCard_data__1whKe","legend":"MonthCard_legend__u9GC_","item":"MonthCard_item__MTOxy"};